<template>
  <div
    class="bg-white overflow-x-auto rounded-xl border border-gray-300 mx-4 mt-4 search-complaints"
  >
    <a-table
      :columns="columns"
      rowKey="numero_id_CF"
      :data-source="dataSource"
      :pagination="false"
      :scroll="{ x: '1220px' }"
    >
      <div slot="name" class="title-size font-bold text-gray-500 text-center">
        Nombre del CF
      </div>
      <div
        slot="tipo_id_cf_name"
        class="title-size font-bold text-gray-500 text-center"
      >
        Tipo de identificación
      </div>
      <div
        slot="numero_id_CF"
        class="title-size font-bold text-gray-500 text-center"
      >
        Número de identificación
      </div>
      <div slot="email" class="title-size font-bold text-gray-500 text-center">
        Correo electrónico
      </div>
      <div slot="phone" class="title-size font-bold text-gray-500">
        Teléfono
      </div>
      <div
        slot="creation_date"
        class="title-size font-bold text-gray-500 text-center"
      >
        Fecha de actualización
      </div>
      <div slot="actions" class="title-size font-bold text-gray-500">
        Acciones
      </div>

      <div slot="actions" slot-scope="text, record">
        <button
          class="flex justify-center col-span-4 text-xs mx-auto text-blue h-min"
          @click="consumDetail(record)"
        >
          <a-icon
            type="eye"
            theme="twoTone"
            two-tone-color="#3366cc"
            :style="{
              fontSize: '20px',
            }"
          />
          <b class="my-auto ml-2">Ver</b>
        </button>
      </div>
    </a-table>
  </div>
</template>

<script>
const columns = [
  {
    slots: { title: "name" },
    dataIndex: "name",
    key: "name",
    width: 170,
  },
  {
    slots: { title: "tipo_id_cf_name" },
    dataIndex: "tipo_id_cf_name",
    key: "tipo_id_cf_name",
    width: 170,
  },
  {
    slots: { title: "numero_id_CF" },
    dataIndex: "numero_id_CF",
    key: "numero_id_CF",
    width: 170,
  },
  {
    slots: { title: "email" },
    dataIndex: "email",
    key: "email",
    width: 170,
  },
  {
    slots: { title: "phone" },
    dataIndex: "phone",
    key: "phone",
    width: 170,
  },
  {
    slots: { title: "creation_date" },
    dataIndex: "creation_date",
    key: "creation_date",
    width: 170,
  },
  {
    slots: { title: "actions" },
    dataIndex: "actions",
    key: "actions",
    scopedSlots: { customRender: "actions" },
    width: 170,
  },
];

export default {
  props: ["dataSource"],
  data() {
    return {
      columns,
    };
  },
  methods: {
    consumDetail(record) {
      this.$router.push(`/dashboard/users/historical/${record.id}`);
    },
  },
};
</script>
